export default __webpack_public_path__ + "static/1-13b30e4abf47dc40ad0812203f4b4c0f.jpeg";